module.exports = __webpack_public_path__ + "static/media/user.eaf7033e.svg";